import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileTopBar } from './MobileTopBar';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return <div className="flex h-screen w-full overflow-hidden bg-background" data-id="element-39">
      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden md:block h-full" data-id="element-40">
        <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} data-id="element-41" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden relative" data-id="element-42">
        {/* Desktop TopBar */}
        <TopBar data-id="element-43" />

        {/* Mobile TopBar (includes sidebar sheet trigger) */}
        <MobileTopBar data-id="element-44" />

        {/* Main Content Area */}
        <main className="flex-1 overflow-auto bg-background w-full" data-id="element-45">
          {children}
        </main>
      </div>
    </div>;
}